import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-api-button2',
  templateUrl: './api-button2.component.html',
  styleUrls: ['./api-button2.component.scss']
})
export class ApiButton2Component implements OnInit {

  @Input() color: 'success' | 'info' | 'warning' | 'default' = 'success'
  @Input() processing: boolean = false

  @Output() click3: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  onClick() {
    if (!this.processing) {
      this.click3.emit()
    }
  }

}
